import fetch from "node-fetch";
import servicesUtils from "./servicesUtils";
import common from "../utils/common";
import http from "./http-service";
import { isArray } from "lodash";

const API_URL = '/api';

const checkAndParse = common.compose(servicesUtils.parseJSON, servicesUtils.checkStatus)

export const dbServices = {
  async uploadPDF(payload) {
    try {
      const url =
        `${API_URL}/notificationUniGateUploadPDF/${payload.examinationID}?t=` +
        new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async notificationUniGateUploadScreenshot(payload) {
    try {
      const url =
        `${API_URL}/notificationUniGateUploadScreenshot/${payload.examinationID}?t=` +
        new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async searchExaminations({
    page,
    pgsz,
    st,
    et,
    accNo,
    patientID,
    orderDoctorID,
  }) {
    try {
      let condition = `page=${page}&pgsz=${pgsz}&st=${st}&et=${et}`;
      accNo && (condition += `&accNo=${accNo}`);
      patientID && (condition += `&patientID=${patientID}`);
      orderDoctorID && (condition += `&orderDoctorID=${orderDoctorID}`);
      let time = new Date().getTime().toString();

      const url = `${API_URL}/v2/examination/search?${condition}&t=${time}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchExaminations(condition) {
    try {
      // const url = timeFrame? `${API_URL}/examinations/list/${timeFrame}?t=` + (new Date()).getTime().toString() : `${API_URL}/examinations/list?t=` + (new Date()).getTime().toString();

      const url =
        `${API_URL}/examinations/list?` +
        servicesUtils.queryParams(condition) +
        `&t=` +
        new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async fetchNewExaminations() {
    try {
      const url = `${API_URL}/worklist/b?t=` + new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async sendDICOMSR(examinationID) {
    try {
      const url =
        `${API_URL}/worklist/c/${examinationID}?t=` +
        new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async fetchExaminationInfos() {
    try {
      const url =
        `${API_URL}/examinations/infoList?t=` + new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchExaminationDetailAndOtherList(payload) {
    try {
      const user = sessionStorage.getItem("user")
      const userObject = JSON.parse(user);
      const username = userObject.username;

      let baseUrl;
      if (Number(payload.accNo) != 0) {
        baseUrl =
          `${API_URL}/examinations/0/accNo/${payload.accNo}/detail/otherList?t=` +
          new Date().getTime().toString();
      } else {
        baseUrl =
          `${API_URL}/examinations/${payload.examinationID}/accNo/0/detail/otherList?t=` +
          new Date().getTime().toString();
      }

      const params = new URLSearchParams({
        t: new Date().getTime().toString(),
        username: username
      })

      const url = `${baseUrl}?${params.toString()}`
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchExaminationDetail(examinationID) {
    try {
      const url =
        `${API_URL}/examinations/${examinationID}/detail?t=` +
        new Date().getTime().toString();

      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async fetchFindings(examinationID) {
    try {
      const url =
        `${API_URL}/examinations/${examinationID}/findings?t=` +
        new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchQuestionJSON(questionID) {
    try {
      const url =
        `${API_URL}/public/question-json-file/${questionID}.json?t=` +
        new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateExaminationStatus(id) {
    try {
      const params = {
        status: "1",
      };

      const url =
        `${API_URL}/examinations/update/status/${id}?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateReportStatus(d) {
    try {
      // 帶上目前登入帳號：後端遙測（fleet M2）用它記錄報告「產出者帳號」，
      // 以區分「按下定稿的人」與「該檢查的執行醫師」（可能不同人）。
      // 取法與 updateQuestionInput 一致（sessionStorage 的 user）；
      // 取不到不阻斷定稿——後端會退化為 null。
      let username;
      try {
        const user = sessionStorage.getItem("user");
        username = user ? JSON.parse(user).username : undefined;
      } catch (err) {
        void 0;
      }

      const url =
        `${API_URL}/examinations/update/reportStatus/${d.id}?t=` +
        new Date().getTime().toString();
      const params = {
        reportStatus: d.value,
        username,
      };

      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateQuestionInput(d) {
    try {
      const user = sessionStorage.getItem("user")
      const userObject = JSON.parse(user);
      const username = userObject.username;

      const url =
        `${API_URL}/examinations/update/questionInput?t=` +
        new Date().getTime().toString();
      const params = {
        examination_typeID: d.examination_typeID,
        findingID: d.findingID,
        recordID: d.recordID,
        field: d.field,
        value: d.value,
        username: username,
        // KAN-5：forward-only append 單顆息肉時帶此旗標，讓後端 number 路徑改複製「前一顆」location
        appendLesion: d.appendLesion,
      };

      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateRecordInput(d) {
    try {
      const url =
        `${API_URL}/examinations/update/recordInput?t=` +
        new Date().getTime().toString();
      const params = {
        recordID: d.recordID,
        field: d.field,
        value: d.value,
      };

      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateExaminationColumn(d) {
    try {
      const params = {
        column: d.column,
        value: ['indication', 'clean_medID', 'antiplateletID', 'antispasmodicReason', 'complication', 'antispasmodicID']
          .includes(d.column) && isArray(d.value) ? d.value.join(',') : d.value,
      };

      const url =
        `${API_URL}/examinations/update/column/${d.id}?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async addFinding(examinationID) {
    try {
      const user = sessionStorage.getItem("user")
      const userObject = JSON.parse(user);
      const username = userObject.username;

      const url =
        `${API_URL}/examinations/${examinationID}/finding/add?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ username }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async deleteFinding(findingID) {
    try {
      const url =
        `${API_URL}/examinations/${findingID}/finding/delete?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async addExaminationSedative(examinationID) {
    try {
      const url =
        `${API_URL}/examinations/${examinationID}/sedative/add?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async deleteExaminationSedative(examinationSedativeID) {
    try {
      const url =
        `${API_URL}/examinations/${examinationSedativeID}/sedative/delete?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateExaminationSedativeColumn(d) {
    try {
      const params = {
        column: d.column,
        value: d.value,
      };

      const url =
        `${API_URL}/examinations/update/examinationSedativeColumn/${d.id}?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async addExaminationLocation(recordID) {
    try {
      const url =
        `${API_URL}/examinations/${recordID}/location/add?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async deleteExaminationLocation(examinationLocationID) {
    try {
      const url =
        `${API_URL}/examinations/${examinationLocationID}/location/delete?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async updateExaminationLocationColumn(d) {
    try {
      const params = {
        column: d.column,
        value: d.value,
      };
      const url =
        `${API_URL}/examinations/update/examinationLocationColumn/${d.id}?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateExaminationInfoColumn(obj) {
    try {
      const url =
        `${API_URL}/examinations/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (e) {
      void 0;
    }
  },
  async addExamination(obj) {
    try {
      // old api
      //const url = `${API_URL}/examinations/add?t=` + (new Date()).getTime().toString();
      let time = new Date().getTime().toString();
      const url = `${API_URL}/v2/examination/add?t=${time}`;

      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (e) {
      void 0;
    }
  },
  async writeRecordDiagnosis(recordID) {
    try {
      const url =
        `${API_URL}/tool/write-record-diagnosis/${recordID}?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "PUT",
        body: JSON.stringify({}),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
  async getOrderArticle(examinationID) {
    try {
      const url = `${API_URL}/examinations/${examinationID}/article?t=${new Date().getTime().toString()}`;
      const res = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (error) {
      // regardless
    }
  },
  async fetchDescriptiveParagraph(eid, etype) {
    const params = new URLSearchParams()
    params.append('eid', eid)
    params.append('etype', etype)
    params.append('t', Date.now().toString())
    try {
      const res = await fetch(`${API_URL}/examinations/descriptive/paragraph?${params}`, {
        headers: {
          "Content-Type": "application/json",
        },
        cache: 'no-store',
      });
      const data = servicesUtils.checkStatus(res);
      const result = await servicesUtils.parseJSON(data);
      return result;
    } catch (error) {
      void 0
      return null
    }
  },
  async updateDescriptiveParagraph(body) {
    try {
      const res = await fetch(`${API_URL}/examinations/descriptive/paragraph`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: 'PUT',
        body: JSON.stringify(body),
      });
      const data = servicesUtils.checkStatus(res);
      const result = await servicesUtils.parseJSON(data);
      return result;
    } catch (error) {
      void 0
      return null
    }
  },

  async sendEmail(eid, etype, email) {
    try {
      const params = new URLSearchParams({
        eid: eid,
        etype: etype
      })
      const body = {
        email: email
      }

      const res = await fetch(`${API_URL}/examinations/sendmail?${params}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: 'PUT',
        body: JSON.stringify(body),
      })
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const result = await res.json(); // Assuming the server responds with JSON
      void 0;
      return result;
    } catch (error) {
      void 0;
      throw error;
    }
  },
  async get_setting(body) {
    try {
      const res = await fetch(`${API_URL}/setting`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: 'GET',
        body: JSON.stringify(body),
      });
      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (error) {
      // regardless
    }
  }
};

export const screenshotServices = {
  async setScreenshotGroup(d) {
    try {
      const url =
        `${API_URL}/image?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(d),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async setScreenshotStatus(d) {
    try {
      const params = {
        id: d,
      };

      const url =
        `${API_URL}/screenSetStatus?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async deleteScreenshot(d) {
    try {
      const url = `${API_URL}/image/${d}?t=${new Date().getTime().toString()}`

      const res = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const organizationServices = {
  async fetchOrganizations() {
    try {
      const url =
        `${API_URL}/organizations/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addOrganization(obj) {
    try {
      const url =
        `${API_URL}/organizations/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateOrganizationColumn(obj) {
    try {
      const url =
        `${API_URL}/organizations/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const doctorServices = {
  async searchDoctor({ keyword }) {
    let xssFilter = new RegExp(
      /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/gi
    );
    try {
      let kwXssPrevent = xssFilter.test(keyword)
        ? (kwXssPrevent = "")
        : keyword;
      kwXssPrevent = kwXssPrevent.replace(/[<-[\]/{}()*+?&.\\^$|]/g, "");
      const url =
        `${API_URL}/v2/autoCompelete/doctor/name?kw=${kwXssPrevent}&t=` +
        new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchDoctors() {
    try {
      const url =
        `${API_URL}/doctors/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addDoctor(obj) {
    try {
      const url = `${API_URL}/doctors/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateDoctorColumn(obj) {
    try {
      const url =
        `${API_URL}/doctors/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const landmarkServices = {
  async fetchLandmarks() {
    try {
      const url =
        `${API_URL}/landmarks/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addLandmark(obj) {
    try {
      const url =
        `${API_URL}/landmarks/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateLandmarkColumn(obj) {
    try {
      const url =
        `${API_URL}/landmarks/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const sedativesServices = {
  async fetchSedatives() {
    try {
      const url =
        `${API_URL}/sedatives/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addSedative(obj) {
    try {
      const url =
        `${API_URL}/sedatives/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateSedativeColumn(obj) {
    try {
      const url =
        `${API_URL}/sedatives/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const examinationTypeServices = {
  async fetchExaminationTypes() {
    try {
      const url =
        `${API_URL}/examinationTypes/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addExaminationType(obj) {
    try {
      const url =
        `${API_URL}/examinationTypes/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateExaminationTypeColumn(obj) {
    try {
      const url =
        `${API_URL}/examinationTypes/update?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const employeeTypeServices = {
  async fetchEmployeeTypes() {
    try {
      const url =
        `${API_URL}/employeeTypes/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addEmployeeType(obj) {
    try {
      const url =
        `${API_URL}/employeeTypes/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateEmployeeTypeColumn(obj) {
    try {
      const url =
        `${API_URL}/employeeTypes/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const userServices = {
  async fetchUsers() {
    try {
      const url = `${API_URL}/users/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addUser(obj) {
    try {
      const url = `${API_URL}/users/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateUserColumn(obj) {
    try {
      const url =
        `${API_URL}/users/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      throw (e)
      //   console.log(e);
    }
  },
};

export const patientServices = {
  async searchPatient({ keyword }) {
    let xssFilter = new RegExp(
      /(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/gi
    );
    try {
      let kwXssPrevent = xssFilter.test(keyword)
        ? (kwXssPrevent = "")
        : keyword;
      kwXssPrevent = kwXssPrevent.replace(/[<-[\]/{}()*+?&.\\^$|]/g, "");
      let time = new Date().getTime().toString();
      const url = `${API_URL}/v2/autoCompelete/patient/name?kw=${kwXssPrevent}&t=${time}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async searchPatients({ page, pgsz, birthday, no, name, gender, nationId }) {
    try {
      let condition = `page=${page}&pgsz=${pgsz}`;
      birthday && (condition += `&birthday=${birthday}`);
      no && (condition += `&no=${no}`);
      name && (condition += `&name=${name}`);
      gender && (condition += `&gender=${gender}`);
      nationId && (condition += `&nationId=${nationId}`);
      let time = new Date().getTime().toString();

      const url = `${API_URL}/v2/patient/search?${condition}&t=${time}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchPatients() {
    try {
      const url =
        `${API_URL}/patients/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addPatient(obj) {
    try {
      const url =
        `${API_URL}/v2/patient/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (e) {
      void 0;
    }
  },

  async updatePatientColumn(obj) {
    try {
      const url =
        `${API_URL}/patients/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await servicesUtils.parseJSON(res);
      return result;
    } catch (e) {
      void 0;
    }
  },
};

export const technicalStaffsServices = {
  async fetchTechnicalStaffs() {
    try {
      const url =
        `${API_URL}/technicalStaffs/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addTechnicalStaff(obj) {
    try {
      const url =
        `${API_URL}/technicalStaffs/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateTechnicalStaffColumn(obj) {
    try {
      const url =
        `${API_URL}/technicalStaffs/update?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const inspectionInstrumentsServices = {
  async fetchInspectionInstruments() {
    try {
      const url =
        `${API_URL}/inspectionInstruments/list?t=` +
        new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addInspectionInstrument(obj) {
    try {
      const url =
        `${API_URL}/inspectionInstruments/add?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateInspectionInstrumentColumn(obj) {
    try {
      const url =
        `${API_URL}/inspectionInstruments/update?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const washInstrumentServices = {
  async fetchWashInstruments() {
    try {
      const url =
        `${API_URL}/washInstruments/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addWashInstrument(obj) {
    try {
      const url =
        `${API_URL}/washInstruments/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateWashInstrumentColumn(obj) {
    try {
      const url =
        `${API_URL}/washInstruments/update?t=` +
        new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const cleanMedServices = {
  async fetchCleanMeds() {
    try {
      const url =
        `${API_URL}/cleanMeds/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addCleanMed(obj) {
    try {
      const url =
        `${API_URL}/cleanMeds/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateCleanMedColumn(obj) {
    try {
      const url =
        `${API_URL}/cleanMeds/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const antiplateletServices = {
  async fetchAntiplatelets() {
    try {
      const url =
        `${API_URL}/antiplatelets/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addAntiplatelet(obj) {
    try {
      const url =
        `${API_URL}/antiplatelets/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateAntiplateletColumn(obj) {
    try {
      const url =
        `${API_URL}/antiplatelets/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const antispasmodicServices = {
  async fetchAntispasmodics() {
    try {
      const url =
        `${API_URL}/antispasmodics/list?t=` + new Date().getTime().toString();
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);

      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async addAntispasmodic(obj) {
    try {
      const url =
        `${API_URL}/antispasmodics/add?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async updateAntispasmodicColumn(obj) {
    try {
      const url =
        `${API_URL}/antispasmodics/update?t=` + new Date().getTime().toString();
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },
};

export const reportServices = {
  async fetchChineseReport(obj) {
    try {
      const url = `${API_URL}/report/${obj.language}?examinationID=${obj.examinationID}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async fetchQualityReport(obj) {
    try {
      const url = `${API_URL}/report/quality?examinationID=${obj.examinationID}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async uploadHISReport(obj) {
    try {
      const url = `${API_URL}/report/his?examinationId=${obj.examinationId}&worklistId=${obj.worklistId}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async uploadHPAReport(obj) {
    try {
      const url = `${API_URL}/report/hpa?examinationId=${obj.examinationId}&worklistId=${obj.worklistId}`;
      const res = await fetch(url);
      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async sendSRReport(examinationID) {
    try {
      const url =
        `${API_URL}/examinations/sendReport?t=` +
        new Date().getTime().toString();

      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ examinationID }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = servicesUtils.checkStatus(res);
      return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  },

  async transferToNewAccNo(obj) {
    try {
      const url = `/report/transfer/patient/${obj.patientId}/acc/${obj.accNo}`;
      const res = await http.fetch(url, {
        method: "POST",
        body: JSON.stringify({
          newAccNo: obj.newAccNo,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      return res.data;
    } catch (e) {
      void 0;
      return e;
    }
  },
  async fetchReportTime(eid) {
    try {
      return await fetch(`${API_URL}/report/time/${eid}`, {
        method: 'GET',
        headers: { "Content-Type": "application/json" },
      }).then(checkAndParse)
    } catch (e) {
      void 0
    }
  },
  async updateReportTime(eid, reporting_time) {
    try {
      return await fetch(`${API_URL}/report/setTime/${eid}`, {
        method: 'PUT',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reporting_time })
      }).then(checkAndParse)
    } catch (e) {
      void 0
    }
  },
};

export const analyticsServices = {
  async fetchSearchFinding() {
    try {
      const { data } = await fetch(`${API_URL}/analytics/search/finding`).then(
        checkAndParse
      );
      return data;
    } catch (e) {
      void 0;
    }
  },
  async fetchSearchLocation() {
    try {
      const { data } = await fetch(`${API_URL}/analytics/search/location`).then(
        checkAndParse
      );
      return data;
    } catch (e) {
      void 0;
    }
  },
  async fetchSearchIntervention() {
    try {
      const { data } = await fetch(
        `${API_URL}/analytics/search/intervention`
      ).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  },
  async search(params) {
    try {
      const { data } = await fetch(`${API_URL}/analytics/search`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  },
  async queryPDR(params) {
    try {
      const { data } = await fetch(`${API_URL}/analytics/pdr`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  },
  async queryWithdrawTime(params) {
    try {
      const { data } = await fetch(`${API_URL}/analytics/withdrawTime`, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  },
};


export const ttsServices = {
  async getAudioFeedBack(commands, url) {
    try {
      const params = {
        commands,
        "voice": "en-US-Neural2-E"
      };
      const res = await fetch(url, {
        method: "POST",
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(res => {
        return res.blob()
      })
      return res

      // const data = servicesUtils.checkStatus(res);
      // return servicesUtils.parseJSON(data);
    } catch (e) {
      void 0;
    }
  }
}

export const asrService = {
  async speechRecognition(params) {
    try {
      const data = await fetch(`${API_URL}/speech-recognition`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  },
  async saveFrontendLog(frontEndLog) {
    try {
      const data = await fetch(`${API_URL}/frontEndLog`, {
        method: 'POST',
        body: JSON.stringify({ frontEndLog }),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(checkAndParse);
      return data;
    } catch (e) {
      void 0;
    }
  }
}
